export default class Images {
  static FallbackProfileImage = "https://rowherostorageprod.blob.core.windows.net/domain-images/people/no-profile.jpg";

  static personProfileImageFromId = (personId: string): string => {
    return personId
      ? "https://rowherostorageprod.blob.core.windows.net/domain-images/people/" + personId + ".jpg"
      : Images.FallbackProfileImage;
  }
}